import { render, staticRenderFns } from "./MYP101P01.vue?vue&type=template&id=66b08af1&scoped=true&"
import script from "./MYP101P01.vue?vue&type=script&lang=js&"
export * from "./MYP101P01.vue?vue&type=script&lang=js&"
import style0 from "./MYP101P01.vue?vue&type=style&index=0&id=66b08af1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b08af1",
  null
  
)

export default component.exports